import styled from "styled-components"
import Img from "gatsby-image"
import media from "src/styles/media"
import TransitionLink from "src/components/util/TransitionLink"

export const PortfolioDestaquesWrapper = styled.section`
  padding-top: 120px;
  padding-bottom: 40px;

  ${media.lessThan("md")`
        padding-top: 40px;
    `}
`

export const PortfolioDestaquesContent = styled.div``

export const PortfolioDestaquesHeader = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--dark);
  margin-bottom: 60px;

  ${media.lessThan("lg")`
        margin-bottom: 25px;
    `}
`

export const PortfolioDestaquesDivisor = styled(Img)`
  width: 54px;
  margin-bottom: 45px;

  img {
    object-fit: contain !important;
  }

  ${media.lessThan("md")`
        width: 40px;
    `}
`

export const PortfolioDestaquesDesc = styled.p`
  font-size: 18px;
  font-weight: 300;
  line-height: 0.8;
  margin-bottom: 9px;
  letter-spacing: 1px;
  text-align: center;

  ${media.lessThan("md")`
        font-size: 17px;
    `}
`

export const PortfolioDestaquesTitle = styled.h1`
  font-size: 62px;
  font-weight: 600;
  line-height: 0.8;
  margin-bottom: 17px;
  letter-spacing: -1px;

  ${media.lessThan("lg")`
        font-size: 50px;
        margin-bottom: 16px;
    `}

  ${media.lessThan("sm")`
        font-size: 40px;
    `}
`

export const PortfolioDestaquesMore = styled(TransitionLink)`
  display: flex;
  justify-content: center;
  margin-top: 40px;

  &:hover {
    text-decoration: none;
  }

  ${media.lessThan("lg")`
        margin-top: 30px;
    `}
`
